export default {
    namespaced: true,
    state: {
        lenguages: [],
        translations: null,
        lang: null,
    },
    actions: {
        getList: async function ({ commit, dispatch }) {
            let response = await axios.get("/api/lenguaje?query=estado.1");
            let lang = localStorage.getItem("lang");
            if (response) {
                let decode = response.decode ?? response;
                if (decode.data) {
                    let langs = decode.data.data ?? [];
                    langs.forEach((element) => {
                        if (lang == null || lang == "") {
                            if (element.defecto) {
                                if (this.state.language.lang == null) {
                                    localStorage.setItem(
                                        "lang",
                                        JSON.stringify(element)
                                    );
                                    commit("setLang", { data: element });
                                }
                            }
                        }
                    });
                    commit("setData", { data: langs });
                    dispatch("setLan");
                    dispatch("getTranslations");
                }
            }
        },
        getTranslations: async function ({ commit, dispatch }) {
            let decode = null;
            let response = null;
            let lang = JSON.parse(localStorage.getItem("lang"));
            if (lang) {
                response = await axios.get(
                    "/api/traductor/traducciones/" + lang.id
                );
                if (response) {
                    decode = response.decode ?? response;
                }
            }
            try {
                let references = JSON.parse(decode.data.content);
                let object = {};
                references.forEach((element) => {
                    let key = Object.keys(element)[0];
                    //console.log(key);
                    object[key] = element[key];
                });
                //console.log(object);
                commit("setTranslations", { data: object });
            } catch (error) {}
        },
        setLan: async function ({ commit, dispatch }) {
            let lang = localStorage.getItem("lang");
            if (lang != null) {
                lang = JSON.parse(lang);
                let response = await axios.get(
                    "/api/lenguaje/cambiar/" + lang.id
                );
            }
            dispatch("getTranslations");
        },
        getLenguage: async function ({ commit, dispatch }) {
            commit("setLang", {
                data: JSON.parse(localStorage.getItem("lang")),
            });
            await dispatch("setLan");
        },
        setLenguage: async function ({ commit, dispatch }, payload) {
            localStorage.setItem("lang", JSON.stringify(payload.lan));
            commit("setLang", { data: payload.lan });
            await dispatch("setLan");
        },
    },
    mutations: {
        setLang(state, payload) {
            state.lang = payload.data;
        },
        setTranslations(state, payload) {
            if (payload.data != undefined) {
                state.translations = payload.data;
            }
        },
        setData(state, payload) {
            if (payload.data != undefined) {
                state.lenguages = payload.data;
            }
        },
    },
};
